'use client';

import { shouldEnableSentry } from '@/utils/common/environment';
import { captureException } from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';
export default function GlobalError({
  error
}: Readonly<{
  error: Error & {
    digest?: string;
  };
}>) {
  useEffect(() => {
    if (shouldEnableSentry()) {
      captureException(error);
    }
  }, [error]);
  return <html lang="en" data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        <NextError statusCode={0} data-sentry-element="NextError" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>;
}